import type {
    ApplicationSettingTheme,
    BlockType,
    DesignStyle,
    DesignThemeType,
    InteractionStyleBreakPointConfigProtocol
} from '@lighthouse/core'
import chroma from 'chroma-js'
import { find, multiply } from 'rambda'

export type DesignAndInteractionStyle = { design?: DesignStyle } & InteractionStyleBreakPointConfigProtocol

export type ThemeDesignInitConfig = DesignAndInteractionStyle & {
    // 成员字段样式
    personDesign?: DesignAndInteractionStyle

    // 滑动条样式
    sliderDesign?: Pick<DesignAndInteractionStyle, 'design'>

    // 已上传附件样式
    fileDesign?: DesignAndInteractionStyle

    selectDesign?: DesignAndInteractionStyle
}

type ThemeBlockDesignInitConfig = Record<DesignThemeType, ThemeDesignInitConfig | undefined>

export const themeBlockDesignConfig = (type: BlockType, theme: ApplicationSettingTheme): ThemeBlockDesignInitConfig => {
    const themeId = theme.primaryPointer
    const themeColor = find(item => item.id === themeId, theme.palettes)?.value || '#101828'
    const color = chroma(themeColor)
    const [h, s, v] = color.hsv()
    const notNaNH = Number.isNaN(h) ? 0 : h
    const alpha = color.alpha()
    const opacity = multiply(alpha, 0.1)
    const tinyThemeColor = chroma(notNaNH, s, v, opacity, 'hsv').hex()
    if (type === 'filter') {
        return {
            LIGHT: {
                design: {
                    theme: 'LIGHT',
                    labelColor: { type: 'color', color: '#101828' },
                    color: { type: 'color', color: '#98a2b3' },
                    iconColor: { type: 'color', color: '#98A2B3' },
                    background: { type: 'color', color: '#F9FAFB' },
                    radius: [4, 4, 4, 4]
                },
                hoverStyle: {
                    open: true,
                    design: {
                        color: { type: 'color', color: '#101828' },
                        iconColor: { type: 'color', color: '#98A2B3' }
                    }
                },
                activeStyle: {
                    open: true,
                    design: {
                        color: { type: 'color', color: themeId },
                        iconColor: { type: 'color', color: themeId },
                        radius: [4, 4, 4, 4],
                        background: { type: 'color', color: tinyThemeColor }
                    }
                }
            },
            DARK: {
                design: {
                    theme: 'DARK',
                    labelColor: { type: 'color', color: '#ffffff' },
                    color: { type: 'color', color: '#ffffff' },
                    iconColor: { type: 'color', color: '#858688' },
                    background: { type: 'color', color: '#1F1F1F' },
                    radius: [4, 4, 4, 4]
                },
                hoverStyle: {
                    open: true,
                    design: {
                        color: { type: 'color', color: '#ffffff' },
                        iconColor: { type: 'color', color: '#858688' }
                    }
                },
                activeStyle: {
                    open: true,
                    design: {
                        color: { type: 'color', color: themeId },
                        iconColor: { type: 'color', color: themeId },
                        radius: [4, 4, 4, 4],
                        background: { type: 'color', color: tinyThemeColor }
                    }
                }
            },
            CUSTOM: undefined
        }
    }

    return {
        LIGHT: undefined,
        DARK: undefined,
        CUSTOM: undefined
    }
}
